import { ValidationType } from "./ValidationType";

export type ValidationMessageType = Record<ValidationType, string>;

export const validationMessage: ValidationMessageType = {
    url: "Please provide a valid URL",
    email: "Please provide a valid email address.",
    number: "Please provide a valid number",
    required: "Please provide a valid input"
};